import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import OpportunityService from '../../../../Services/opportunityService';
import ErrorMessage from '../../../ErrorMessage';

export default class ProjectOpportunitySelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    multipleIdFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.validateMultipleIdFilter(prevProps)) {
      this.populateListData();
    }
  }

  validateMultipleIdFilter(prevProps) {
    return (
      this.props.multipleIdFilter &&
      this.props.multipleIdFilter.ClientId !== '' &&
      this.props.multipleIdFilter.CfStartDate !== undefined &&
      this.props.multipleIdFilter.CfEndDate !== undefined &&
      prevProps &&
      prevProps.multipleIdFilter &&
      (this.props.multipleIdFilter.CfStartDate !== prevProps.multipleIdFilter.CfStartDate ||
        this.props.multipleIdFilter.CfEndDate !== prevProps.multipleIdFilter.CfEndDate)
    );
  }

  populateListData() {
    if (this.validateMultipleIdFilter()) {
      this.setState({ selectValues: [] });
      return;
    }

    OpportunityService.GetAllOpportunitiesForNewProject(
      this.props.multipleIdFilter.ClientId,
      this.props.multipleIdFilter.CfStartDate,
      this.props.multipleIdFilter.CfEndDate
    )
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .forEach((opportunity, index) => {
            optValues.push({
              label: `${opportunity.opportunityId} - ${opportunity.name}`,
              value: opportunity.opportunityId,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('POS72');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
